// src/components/customer-search/CustomerSearch.tsx
import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMyCustomers } from "../../hooks/useMyCustomers";
import { RootState } from "../../store";
import {
  MyCustomerApiRequest,
  MyCustomerApiResponse,
} from "../../store/services/customerService";
import { setCustomerSearchFilter } from "../../store/slices/customerSearchFilterSlice";
import CustomerContextMenu, {
  CustomerAction,
} from "./components/CustomerContextMenu";
import CustomerListBase from "./components/CustomerListBase";
import CustomerTypeFilterTabs from "./components/CustomerTypeFilterTabs";

const CustomerSearch: React.FC = () => {
  const dispatch = useDispatch();

  // Get filter from Redux store
  const filter = useSelector(
    (state: RootState) => state.customerSearchFilter.filter
  );

  // Update filter via Redux
  const handleFilterChange = (newFilter: Partial<MyCustomerApiRequest>) => {
    dispatch(setCustomerSearchFilter(newFilter));
  };

  console.log("CustomerSearch filter", filter);
  const {
    data = [],
    error,
    isLoading,
    isFetching,
  } = useMyCustomers({
    customerType: filter.customerType,
    customerGroupNo:
      filter.customerType !== "company" ? filter.customerGroupNo : undefined,
  });

  // State for context menu and dialogs
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    customer: MyCustomerApiResponse;
  } | null>(null);

  // Handle context menu for My Customers view
  const handleContextMenu = (
    customer: MyCustomerApiResponse,
    event: React.MouseEvent
  ) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY,
      customer,
    });
  };

  // Close context menu
  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  // Handle actions from the customer context menu
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCustomerAction = (action: CustomerAction) => {
    const customer = contextMenu?.customer;
    if (!customer) return;

    /*     switch (action) {
      case "viewDetails":
        // Navigate to details
        navigate(`/customer/${customer.Id}`);
        break;
      case "copyId":
        navigator.clipboard.writeText(customer.CustomerId);
        break;
      case "copyName":
        navigator.clipboard.writeText(customer.Name);
        break;
      // Other actions are handled by the CustomerContextMenu component itself
    } */

    handleCloseContextMenu();
  };

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2} mb={1}>
        <Stack>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              color: "primary.main",
              fontWeight: 700,
              fontSize: { xs: "1.6rem", sm: "2.2rem" },
              letterSpacing: 0.5,
              flexGrow: 1,
            }}
          >
            Mina kunder
          </Typography>
        </Stack>
        {/* Customer Type Filter Tabs */}
        <CustomerTypeFilterTabs
          activeFilters={filter as MyCustomerApiRequest}
          onFilterChange={handleFilterChange}
        />
      </Stack>
      <CustomerListBase
        customers={data}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        renderContextMenu={handleContextMenu}
      />
      {/*   <CustomerTypesenseToggle
        customers={data?.SalesCustomers || []}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        renderContextMenu={handleContextMenu}
        allowToggle={true}
        defaultUseTypesense={false}
        showPerformanceInfo={true}
      /> */}
      {/* Customer Context Menu */}
      <CustomerContextMenu
        contextMenu={contextMenu}
        onClose={handleCloseContextMenu}
        onAction={handleCustomerAction}
      />
    </>
  );
};

export default CustomerSearch;
